import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ requiredRole, children }) {
  const { user, loading } = useAuth();

  // 1. Wait for authentication to finish checking
  if (loading) {
    return <div className="p-8 text-center text-gray-500">Verifying session...</div>;
  }

  // 2. If not logged in, kick to login screen
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Role verification (Allows the specified role, or super_admin)
  if (requiredRole && user.role !== requiredRole && user.role !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  // 4. THE FIX: If wrapped around a component (like AdminDashboard), render it. 
  // Otherwise, render the Outlet for nested routes.
  return children ? children : <Outlet />;
}